<div id="footer" class="text-gray-500 pt-5">
  <span>&copy; {{ companyName }} {{ version }} </span><span class="account-id">&nbsp;({{ accountId$ | async }})</span>
</div>
